import { Type } from 'class-transformer';
import { BaseResidentParameterDto } from '../../_models/base-resident-parameter-dto';

export class ViolationParameterDto extends BaseResidentParameterDto {
  open: boolean;
  @Type(() => Date)
  periodBegin: Date;
  @Type(() => Date)
  periodEnd: Date;

  constructor(open: boolean, customerId?: string, communityId?: number) {
    super(customerId, communityId);
    this.open = open;
  }

  override getQueryString(): string {
    const url: string = `?customerId=${this.customerId}&communityId=${this.communityId}&open=${this.open}&clearCache=${this.clearCache}`;
    return url;
  }
}
